// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1x-6";
export var headerCell = "_1x-2";
export var rowWrapper = "_1x-4";
export var stickyAggregationCell = "_1x-a";
export var stickyAggregationRow = "_1x-7";
export var stickyColumnCell = "_1x-9";
export var stickyColumnHeaderCell = "_1x-8";
export var table = "_1x-1";
export var virtualRowWrapper = "_1x-5";
export var virtualTableContainer = "_1x-0";
export var white = "_1x-3";